module.exports = __webpack_public_path__ + "img/womanhead.8328ceb1.png";